import { render, staticRenderFns } from "./BackupsUsageItem.vue?vue&type=template&id=0de318bc&scoped=true"
import script from "./BackupsUsageItem.vue?vue&type=script&lang=js"
export * from "./BackupsUsageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de318bc",
  null
  
)

export default component.exports